/**
 * @file Identity Name container.
 */

import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';

import IdentityName from '../../../components/global/identity/IdentityName';
import { MeQuery } from '../../../graphql/queries/account';

const withUser = graphql(MeQuery, {
  props: ({ data: { me, loading } }) => ({
    user: me,
    loading,
  }),
});

export default compose(withUser)(IdentityName);
